import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Welcome from "./details/Welcome";
import Body from "./details/Body";
import NotFound from "../NotFound";
import SEO from "../common/SEO";

const ConcertDetails = ({ formatDate, renderBody, concerts }) => {
  const { id } = useParams();
  const concert = concerts.find((obj) => obj.id === id);
  const { t, i18n } = useTranslation();

  if (!concert) {
    return <NotFound />;
  }

  const isExpired = new Date(concert.date) < new Date();
  const lang = (i18n.language || "it").substring(0, 2);
  const formattedConcertDate = formatDate(concert.date);
  const introText = lang === "en" ? (concert.intro_en || concert.intro_it) : (concert.intro_it || concert.intro_en);
  
  const desc = introText
    ? introText.split("\n")[0].substring(0, 160)
    : `Concerto "${concert.title}" della Nuova Orchestra da Camera Ferruccio Busoni. Data: ${formattedConcertDate}${concert.time ? ` ore ${concert.time}` : ""}${concert.place ? ` presso ${concert.place}` : ""}.`;

  const concertSocialImg = concert.img ? (concert.img.startsWith("http") ? concert.img : `https://www.orchestrabusoni.it${concert.img}`) : undefined;

  const eventSchema = {
    "@type": "MusicEvent",
    "name": concert.title,
    "startDate": `${concert.date}T${concert.time ? concert.time.replace('.', ':') : "20:30"}:00`,
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "location": {
      "@type": "Place",
      "name": concert.place || "Trieste",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Trieste",
        "addressCountry": "IT",
      },
    },
    "image": concertSocialImg,
    "description": desc,
    "performer": {
      "@type": "MusicGroup",
      "name": "Nuova Orchestra da Camera Ferruccio Busoni",
      "url": "https://www.orchestrabusoni.it",
    },
    "organizer": {
      "@type": "Organization",
      "name": "Nuova Orchestra da Camera Ferruccio Busoni",
      "url": "https://www.orchestrabusoni.it",
      "logo": "https://www.orchestrabusoni.it/logo.png",
    },
    "offers": concert.buy_link ? {
      "@type": "Offer",
      "url": concert.buy_link,
      "availability": isExpired ? "https://schema.org/Discontinued" : "https://schema.org/InStock",
      "price": "0",
      "priceCurrency": "EUR",
    } : undefined,
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: lang === "en" ? "Concerts" : "Concerti", url: "/concerts" },
    { name: concert.title, url: `/concerts/${concert.id}` },
  ];

  return (
    <>
      <SEO
        title={`${concert.title} - ${formattedConcertDate}`}
        description={desc}
        image={concert.img}
        type="music.event"
        schema={eventSchema}
        breadcrumbs={breadcrumbs}
      />
      <Welcome
        concert={concert}
        t={t}
        formatDate={formatDate}
        isExpired={isExpired}
      />
      <Body
        concert={concert}
        t={t}
        i18n={i18n}
        renderBody={renderBody}
        isExpired={isExpired}
      />
    </>
  );
};

export default ConcertDetails;
